import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type {
    IConfigurationGroup,
    IConfigurationGroupRecording,
    IResponseWithLoading,
    ISite,
} from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteConfigurationGroupRecordingComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSitesRepository"];

    public configurationGroup: IConfigurationGroup;

    public site: ISite;

    public deleted: (params: { id: string }) => void;

    public configurationGroupRecording: IResponseWithLoading<IConfigurationGroupRecording>;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(
            this.sitesRepository.getConfigurationGroupRecording(
                this.configurationGroup.siteId,
                this.configurationGroup.id,
            ),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result: IResponseWithLoading<IConfigurationGroupRecording>) => {
                    this.configurationGroupRecording = result;
                },
                (result) => {
                    this.configurationGroupRecording = result;
                },
            );
    }

    public editConfiguration() {
        this.modalService
            .open<IConfigurationGroupRecording, void>(
                "mmConfigurationGroupRecordingEdit",
                this.configurationGroupRecording.data,
                null,
                "xlg",
            )
            .subscribe(
                (editedConfiguration) => {
                    if (editedConfiguration !== null) {
                        this.configurationGroupRecording.data = editedConfiguration;
                        this.configurationGroup.name = editedConfiguration.name;
                    } else {
                        this.deleted({ id: this.configurationGroup.id });
                    }
                },
                (reason) => reason,
            );
    }
}
